;(function() {
  'use strict'

  Controller.$inject = ["$element", "$window", "$sce", "configService", "glAuthService", "userService"];
  angular.module('app.core').component('surveyAiEditor', {
    controller: Controller,
    templateUrl: 'survey-ai-editor.html',
    bindings: {
      survey: '=',
      onCreate: '&',
      onSave: '&',
      onModeChange: '&',
    },
  })

  /* @ngInject */
  function Controller(
    $element,
    $window,
    $sce,
    configService,
    glAuthService,
    userService
  ) {
    var ctrl = this

    var iframeOrigin = configService.getSurveyAiEditorOrigin()

    var iframeEl = null
    var iframeWin = null

    ctrl.isSSR = userService.isSSR()

    ctrl.$onInit = onInit
    ctrl.$postLink = postLink
    ctrl.$onDestroy = onDestroy

    function onInit() {
      ctrl.trustedUrl = $sce.trustAsResourceUrl(iframeOrigin)
    }

    function postLink() {
      iframeEl = $element[0].querySelector('iframe')
      iframeWin = iframeEl && iframeEl.contentWindow
      $window.addEventListener('message', onMessage)
    }

    function onDestroy() {
      $window.removeEventListener('message', onMessage)
      iframeWin = null
    }

    function onMessage(event) {
      // 1) must be from expected iframe origin
      if (event.origin !== iframeOrigin) return

      // 2) must be from *this* iframe
      if (iframeWin && event.source !== iframeWin) return

      var msg = event.data
      console.log(msg)

      // 3) must have version and type
      if (!msg || msg.version !== 1 || !msg.type) return

      if (msg.type === 'BRIDGE_HANDSHAKE_REQUEST') {
        postToChild({
          type: 'BRIDGE_HANDSHAKE_RESPONSE',
          authToken: glAuthService.getToken(),
          subscriberId: userService.getSubscriberId(),
          payload: {
            surveyId: ctrl.survey.ai.surveyId,
            conversationId: ctrl.survey.ai.conversationId,
            surveyModifiedByUser: ctrl.survey.ai.surveyModifiedByUser,
            isSSR: ctrl.isSSR,
          },
        })
        console.log('→ Sent: BRIDGE_HANDSHAKE_RESPONSE', 'sent')
      }

      if (msg.type === 'BRIDGE_SAVE_SURVEY_REQUEST') {
        console.log('BRIDGE_SAVE_SURVEY_REQUEST', _.cloneDeep(msg))
        var payload = {
          conversationId: msg.payload.conversationId,
          survey: msg.payload.survey,
        }
        ctrl.survey.transform(payload)
        ctrl.onModeChange()
      }

      if (msg.type === 'BRIDGE_EXIT_REQUEST') {
        console.log('BRIDGE_EXIT_REQUEST', _.cloneDeep(msg))
        ctrl.onModeChange()
      }
    }

    function postToChild(message) {
      if (!iframeWin) return
      iframeWin.postMessage(message, iframeOrigin)
    }
  }
})()
